import {AspectRatio} from '@contentlab/types/aspectRatio';

export enum AssetCategory {
  UPLOADS = 'Uploads',
  RESULTS = 'Results',
}

export type Asset = {
  id: string;
  name: string;
  metadata: {
    durationMillis: number;
    fileSizeBytes: number;
    height: number;
    width: number;
    language?: string;
    aspectRatio?: AspectRatio;
  };
  folderName?: string;
  userID?: string;
  brandID?: string;
  organizationID?: string;
  createdAt?: number;
  originalAsset?: {
    name: string;
    id: string;
  };
  thumbnailUrl?: string;
  type?: 'upload' | 'result';
  url?: string;
  status: string;
};
